import React from "react";
import Link from "common/Link";
import { getFormattedDate } from "utils/getFormattedDateTime";

import { UrlUtils } from "utils/url-utils";

const TableContent = ({ obits = [] }) => {
  const prefix = "root/responsivegrid/obituary_detail/profile";

  return (
    <ul className="table-row-group w-full">
      {obits.length > 0 &&
        obits.map((obit: any, index: number) => {
          const getValue = (key) => obit.customProperties[`${prefix}/${key}`];
          const name = getValue("deceasedName");
          const birthDate = getValue("deceasedBirthDate");
          const deathDate = getValue("deceasedDeathDate");
          const hideDob = getValue("hideDob");
          const hideDod = getValue("hideDod");

          return (
            <li key={index} className="w-full border-b border-[#dbd7be]">
              <Link
                to={`${UrlUtils.getShortUrl(obit.path)}.html`}
                className="table w-full !no-underline group"
              >
                <div className="table-cell align-middle">
                  <div className="flex items-center space-x-4">
                    <img
                      alt="decedent"
                      src={obit.thumbnailPath}
                      className="object-cover w-[100px] h-[100px] shrink-0"
                    />
                    <div className="space-y-2 md:space-y-0">
                      <span className="text-obituary-brown-300 group-hover:text-obituary-brown-100 group-hover:underline">
                        {name}
                      </span>
                      <span className="block text-right align-middle text-obituary-brown-300 group-hover:text-obituary-brown-100 group-hover:underline md:hidden">
                        {hideDob === "false" &&
                          hideDod === "false" &&
                          getFormattedDate(birthDate) +
                            " - " +
                            getFormattedDate(deathDate)}
                        {hideDob === "false" &&
                          hideDod !== "false" &&
                          getFormattedDate(birthDate)}
                        {hideDob !== "false" &&
                          hideDod === "false" &&
                          getFormattedDate(deathDate)}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="text-obituary-brown-300 group-hover:text-obituary-brown-100 group-hover:underline hidden md:table-cell text-right align-middle md:w-48 px-2.5 py-1.5">
                  {hideDob === "false" && getFormattedDate(birthDate)}
                </div>
                <div className="text-obituary-brown-300 group-hover:text-obituary-brown-100 group-hover:underline hidden md:table-cell text-right align-middle md:w-48 px-2.5 py-1.5">
                  {hideDod === "false" && getFormattedDate(deathDate)}
                </div>
              </Link>
            </li>
          );
        })}
    </ul>
  );
};

export default TableContent;
